import logo from "../../assets/images/logo.svg";
import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";

import { getEnvironmentProperties } from "./environmentProperties";

const HomePage = (props) => {
  const {
    subtitle,
    color,
    displayEnvironmentOnScreen,
  } = getEnvironmentProperties();
  const titleStyle = {
    marginBottom: displayEnvironmentOnScreen ? "20px" : "90px",
  };

  return (
    <div className="login-page">
      <div className="login-form">
        <h1>
          <img src={logo} width="200" height="50" alt="Major" />
        </h1>
        <h2 style={titleStyle}>
          <FormattedMessage id="login.title" />
        </h2>
        {displayEnvironmentOnScreen && (
          <h4 style={{ marginBottom: "40px" }}>
            <FormattedMessage id={"login.environments." + subtitle}>
              {(message) => (
                <span
                  style={{
                    backgroundColor: color,
                    borderRadius: "4px",
                    padding: "4px 12px",
                  }}
                >
                  {message}
                </span>
              )}
            </FormattedMessage>
          </h4>
        )}
        <button
            className={`btn btn-primary`}
            type="button"
            onClick={() => location.reload()}
        >
            <FormattedMessage id="login.button" />
        </button>
        {props.children}
      </div>
    </div>
  );
};

HomePage.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.arrayOf(PropTypes.element),
  ]),
};

export default HomePage;



// WEBPACK FOOTER //
// ./src/components/common/HomePage.js